import { Component, Inject, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { SearchSupportRequestReq, SearchSupportRequestRes, SupportRequestAttachmentRes } from '../../core/models/searchSupportRequestList';
import { PageEvent, MatPaginator, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTable } from '@angular/material';
import { CommonService } from '../../core/services/v2/common.service';
import { UserService } from '../../core/services/v2/user.service';
import { PreviewImagesComponent } from '../../shared/components/preview-images/preview-images.component';
import { PreviewDocumentComponent } from '../../shared/components/preview-document/preview-document.component';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-support-bugs',
  templateUrl: './support-bugs.component.html',
  styleUrls: ['./support-bugs.component.scss']
})
export class SupportBugsComponent implements OnInit {


  supportRequests: SearchSupportRequestRes[];
  filteredSupportBugs: SearchSupportRequestRes[];


  @ViewChild('paginator', { static: true }) paginator: MatPaginator;
  @ViewChild(MatTable, { static: false }) table: MatTable<any>;

  displayedColumns = ['supportId', 'createdDate', 'user', 'supportType', 'description', 'status', 'action'];

  pageLength = 10;
  pageIndex = 1;
  totalRecords = 0;
  requestFilter: SearchSupportRequestReq;
  currentUserId: number;
  constructor(
    private commonService: CommonService,
    private userService: UserService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.userService.getUserDetails().subscribe(
      (me) => { this.currentUserId = me.id; },
      (error) => { console.error(error); }
    );

    this.searchSupportBugs();
  }
  openFile(attachment: SupportRequestAttachmentRes) {

    if (attachment.attachmentContentType.toLowerCase().indexOf('image') >= 0) {
      this.dialog.open(PreviewImagesComponent, {
        id: 'previewDocument',
        width: '80%',
        disableClose: true,
        data: {
          documentTitle: attachment.fileName, images: [{ text: attachment.fileName, location: attachment.attachmentUrl }]
        }
      })
    } else if (attachment.attachmentContentType.toLowerCase().indexOf('pdf') >= 0) {
      this.dialog.open(PreviewDocumentComponent, {
        id: 'previewDocument',
        maxWidth: '80%',
        panelClass: 'preview-modal',
        disableClose: true,
        backdropClass: 'preview-modal',
        data: { documentTitle: attachment.fileName, documentLocation: attachment.attachmentUrl }
      });
    }
    else {
      window.open(attachment.attachmentUrl);
    }
  }
  newItems() {
    return this.supportRequests ? this.supportRequests.filter(sr => sr.supportStatus == 'PENDING').length : 0;
  }
  completedItems() {

    return this.supportRequests ? this.supportRequests.filter(sr => sr.supportStatus == 'COMPLETED').length : 0;
  }
  searchSupportBugs(): void {

    this.requestFilter = new SearchSupportRequestReq();
    this.requestFilter.isActive = true;

    this.loaderService.show();

    this.commonService.searchSupportRequests(this.requestFilter).subscribe(
      (response) => {
        console.log(response);
        if (response['response']['isSuccess']) {
          this.supportRequests = response['supportRequests'];
          this.filteredSupportBugs = this.supportRequests;
          this.totalRecords = this.supportRequests.length;
        }
        this.loaderService.hide();
      },
      (error) => { console.error(error); },
      () => { this.loaderService.hide(); }
    );
  }

  changeIndex(event: PageEvent) {
    this.pageLength = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    //this.getAppointments();
    this.table.renderRows();
  }

  updateStatus(item: SearchSupportRequestRes, ind: number) {
    this.loaderService.show();
    var cind = ((this.pageIndex - 1) * this.pageLength) + ind;
    this.commonService.completeSupportRequest(item.id).subscribe(
      (response) => {
        //console.log(response);
        if (response['resultStatus']['isSuccess']) {
          item.supportStatus = 'COMPLETED';
          this.filteredSupportBugs[cind].supportStatus = 'COMPLETED';
          this.table.renderRows();
        }
        this.loaderService.hide();
      },
      (error) => { console.error(error); },
      () => { this.loaderService.hide(); }
    );
  }
}
